<template>
  <div>
    <transition name="fade">
      <div v-if="$parent.popup" class="popup">
        <div class="offclick"></div>
        <div class="holder" v-if="showSuccess">
          <transition name="fade_delay">
            <div v-if="showSuccess">
              <h3 class="thanks">Great! We’ve received your custom design</h3>
              <p>
                The next step is to get an easy 3D scan. We will email you link
                to our calendar to schedule your 5 minute scan.
              </p>
            </div>
          </transition>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <img
        v-if="!showSuccess"
        :class="{ active: !showSuccess }"
        class="loading"
        src="@/assets/img/loader.png"
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: "cart-popup",
  data() {
    return {};
  },
  created() {
    console.log(this.userInfo);
  },
  mounted() {
    let vm = this;
    setTimeout(function() {
      // vm.$router.push({name: 'Home' })
    }, 10000);
  },
  updated() {},
  props: ["billingInfo", "userInfo", "showSuccess"],
  methods: {},
};
</script>

<style scoped>
.thanks {
  text-align: center;
}

.loader {
  width: 200px !important;
  margin: auto;
}

.holder {
  padding: 50px;
}

.holder p {
  line-height: 1.2;
}
</style>
